<template
  ><div>
    <v-text-field
      v-model="searchDate"
      append-icon="mdi-magnify"
      label="Buscar"
      single-line
      hide-details
      class="mx-5 mb-3"
    ></v-text-field>
    <v-data-table
      :headers="headersAppointment"
      :items="appointment"
      :search="searchDate"
      :items-per-page="10"
      :footer-props="{
        'items-per-page-text': 'Elementos por página',
        'items-per-page-all-text': 'Todo',
      }"
      no-results-text="Sin resultados coincidentes con la búsqueda"
      loading-text="Cargando..."
      no-data-text="Sin resultados disponibles"
      class="mx-5"
      dense
      fixed-header
      height="auto"
    >
      <template v-slot:[`item.count`]="{ index }">
        {{ index + 1 }}
      </template>
      <template v-slot:[`item.status`]="{ item }">
        <span v-if="item.status == 1" class="warning--text">{{
          item.nameStatus
        }}</span>
        <span v-if="item.status == 2" class="primary--text">{{
          item.nameStatus
        }}</span>
        <span v-if="item.status == 3" class="success--text">{{
          item.nameStatus
        }}</span>
        <span v-if="item.status == 4" class="error--text">{{
          item.nameStatus
        }}</span>
        <span v-if="item.status == 5" class="grey darken-1--text"
          >{{ item.nameStatus }}
        </span>
        <span v-if="item.status == 6" class="info--text">{{
          item.nameStatus
        }}</span>
        <span v-if="item.status == 7" class="secondary--text">{{
          item.nameStatus
        }}</span>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: { appointment: Array },
  data() {
    return {
      searchDate: "",
      headersAppointment: [
        { text: "#", value: "count" },
        { text: "ID cita ", value: "idAppointment" },
        { text: "Fecha de solicitud", value: "registrationDate" },
        { text: "Especialidad", value: "specialty" },
        { text: "Agendado por", value: "doctorName" },
        { text: "Fecha de cita", value: "appointmentDate" },
        { text: "Sucursal", value: "consultingRoom.branchOffice.name" },
        { text: "Estatus", value: "status" },
      ],
    };
  },
  mounted() {},
  methods: {},
};
</script>

<style></style>
